import { connect } from 'react-redux';
import AppLayout from '../../../components/layout/AppLayout';
import { getViews } from 'core/slices/views';
import { getStoresData } from 'core/slices/stores';
import { getUserInformation } from 'core/slices/users';
export default connect(
  _ => ({}),
  {
    getViews,
    getStoresData,
    getUserInformation,
  },
)(AppLayout);
